const entityHistoryLogEntryStyles = {
  icon: {
    width: 72,
    flexShrink: 0,
  },
  content: {
    minWidth: 0,
    flexGrow: 1,
  },
  header: {
    alignItems: "flex-start",
    flexWrap: "nowrap",
  },
  details: {
    borderTop: 1,
    borderColor: "divider",
    marginTop: "0.75rem",
    paddingTop: "0.75rem",
  },
};

export default entityHistoryLogEntryStyles;
